(function () {
  var controllers = new WeakMap();

  function stateApi() {
    return window.AdventState || null;
  }

  function readConfig(root) {
    var node = root.querySelector('[data-advent-i18n]');
    var i18n = {};
    if (node) {
      try {
        i18n = JSON.parse(node.textContent);
      } catch (error) {
        i18n = {};
      }
    }
    return {
      interaction: root.getAttribute('data-advent-interaction') || 'page',
      testMode: root.getAttribute('data-advent-test-mode') === 'true',
      locale: root.getAttribute('data-advent-locale') || document.documentElement.lang || 'en',
      i18n: i18n,
    };
  }

  function labelFor(count, one, other) {
    return Math.abs(Number(count)) === 1 ? one || '' : other || '';
  }

  function setText(node, value) {
    if (node) node.textContent = value;
  }

  function paintCountdown(countdown, config, nowMs) {
    var api = stateApi();
    if (!api) return null;
    var unlockAt = api.resolveInstant(
      countdown.getAttribute('data-unlock-unix'),
      countdown.getAttribute('data-unlock-iso')
    );
    var remaining = api.remainingMs(unlockAt, nowMs);
    if (remaining == null) return null;
    var parts = api.splitDuration(remaining);
    var i18n = config.i18n;
    setText(countdown.querySelector('[data-advent-unit="days"]'), String(parts.days));
    setText(countdown.querySelector('[data-advent-unit="hours"]'), String(parts.hours));
    setText(countdown.querySelector('[data-advent-unit="minutes"]'), String(parts.minutes));
    setText(countdown.querySelector('[data-advent-unit="seconds"]'), String(parts.seconds));
    setText(
      countdown.querySelector('[data-advent-label="days"]'),
      labelFor(parts.days, i18n.daysOne, i18n.daysOther)
    );
    setText(
      countdown.querySelector('[data-advent-label="hours"]'),
      labelFor(parts.hours, i18n.hoursOne, i18n.hoursOther)
    );
    setText(
      countdown.querySelector('[data-advent-label="minutes"]'),
      labelFor(parts.minutes, i18n.minutesOne, i18n.minutesOther)
    );
    setText(
      countdown.querySelector('[data-advent-label="seconds"]'),
      labelFor(parts.seconds, i18n.secondsOne, i18n.secondsOther)
    );
    return { unlockAt: unlockAt, remaining: remaining, parts: parts };
  }

  function announce(countdown, parts, i18n) {
    var live = countdown.querySelector('[data-advent-live]');
    if (!live) return;
    var key = parts.days + ':' + parts.hours + ':' + parts.minutes;
    if (live.getAttribute('data-advent-announced') === key) return;
    live.setAttribute('data-advent-announced', key);
    live.textContent = [
      parts.days + ' ' + labelFor(parts.days, i18n.daysOne, i18n.daysOther),
      parts.hours + ' ' + labelFor(parts.hours, i18n.hoursOne, i18n.hoursOther),
      parts.minutes + ' ' + labelFor(parts.minutes, i18n.minutesOne, i18n.minutesOther),
    ].join(', ');
  }

  function reloadOnce(key) {
    var storageKey = 'advent-reload:' + key;
    try {
      if (window.sessionStorage.getItem(storageKey) === '1') return;
      window.sessionStorage.setItem(storageKey, '1');
    } catch (error) {
      return;
    }
    window.location.reload();
  }

  function initCountdowns(root, signal, config) {
    var countdowns = root.querySelectorAll('[data-advent-countdown]');
    if (!countdowns.length || !stateApi()) return;

    function tick() {
      var now = Date.now();
      countdowns.forEach(function (countdown) {
        var painted = paintCountdown(countdown, config, now);
        if (!painted) return;
        if (painted.remaining <= 0) {
          var live = countdown.querySelector('[data-advent-live]');
          if (live && config.i18n.opened) live.textContent = config.i18n.opened;
          if (!config.testMode) reloadOnce(painted.unlockAt);
          return;
        }
        if (painted.parts.seconds === 0) announce(countdown, painted.parts, config.i18n);
      });
    }

    tick(false);
    var timer = window.setInterval(function () {
      tick(true);
    }, 1000);
    signal.addEventListener('abort', function () {
      window.clearInterval(timer);
    });
  }

  function initDialog(root, signal) {
    var config = readConfig(root);
    if (config.interaction !== 'overlay') return;
    var dialog = root.querySelector('[data-advent-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var body = dialog.querySelector('[data-advent-dialog-body]');
    var closeButton = dialog.querySelector('[data-advent-close]');
    var trigger = null;

    function unlockScroll() {
      document.documentElement.classList.remove('advent-scroll-lock');
    }

    function closeDialog() {
      if (dialog.open) dialog.close();
    }

    root.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest('[data-advent-open]');
        if (!link || !root.contains(link)) return;
        if (event.defaultPrevented) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        var template = link.parentElement && link.parentElement.querySelector('[data-advent-template]');
        if (!template || !body) return;
        event.preventDefault();
        trigger = link;
        body.replaceChildren(template.content.cloneNode(true));
        var title = body.querySelector('[data-advent-dialog-title]');
        var description = body.querySelector('[data-advent-dialog-description]');
        if (title) {
          title.id = dialog.id + '-title';
          dialog.setAttribute('aria-labelledby', title.id);
        } else {
          dialog.removeAttribute('aria-labelledby');
        }
        if (description) {
          description.id = dialog.id + '-description';
          dialog.setAttribute('aria-describedby', description.id);
        } else {
          dialog.removeAttribute('aria-describedby');
        }
        try {
          if (dialog.open) dialog.close();
          dialog.showModal();
        } catch (error) {
          window.location.assign(link.href);
          return;
        }
        document.documentElement.classList.add('advent-scroll-lock');
        if (closeButton) closeButton.focus();
      },
      { signal: signal }
    );

    dialog.addEventListener(
      'click',
      function (event) {
        if (event.target === dialog) closeDialog();
      },
      { signal: signal }
    );

    if (closeButton) {
      closeButton.addEventListener('click', closeDialog, { signal: signal });
    }

    dialog.addEventListener(
      'close',
      function () {
        unlockScroll();
        if (body) body.replaceChildren();
        dialog.removeAttribute('aria-labelledby');
        dialog.removeAttribute('aria-describedby');
        if (trigger && trigger.isConnected) trigger.focus();
        trigger = null;
      },
      { signal: signal }
    );

    signal.addEventListener('abort', function () {
      if (dialog.open) dialog.close();
      unlockScroll();
    });
  }

  function initRoot(root) {
    if (!(root instanceof Element)) return;
    var previous = controllers.get(root);
    if (previous) previous.abort();
    var controller = new AbortController();
    controllers.set(root, controller);
    var config = readConfig(root);
    initCountdowns(root, controller.signal, config);
    initDialog(root, controller.signal);
  }

  function rootsFrom(target) {
    if (!(target instanceof Element)) return [];
    if (target.matches('[data-advent-root]')) return [target];
    return Array.prototype.slice.call(target.querySelectorAll('[data-advent-root]'));
  }

  function initAll() {
    document.querySelectorAll('[data-advent-root]').forEach(initRoot);
  }

  function destroyTarget(target) {
    rootsFrom(target).forEach(function (root) {
      var controller = controllers.get(root);
      if (controller) controller.abort();
      controllers.delete(root);
    });
  }

  if (!window.__adventCalendarDocumentBound) {
    window.__adventCalendarDocumentBound = true;
    document.addEventListener('shopify:section:load', function (event) {
      rootsFrom(event.target).forEach(initRoot);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      destroyTarget(event.target);
    });
  }

  initAll();
})();
